import { useEffect, useMemo, useState } from 'react';
import BackendService from '../../services/BackendService';
import useAppContext from '../useAppContext/useAppContext';
import { determineMediaState, MediaStates } from '../../commands/practitioner/enums/MediaStates';

const useClientMediaState = (delay = 1000) => {
  const { sessionId, treatmentId } = useAppContext();
  const [practitionerMediaState, setPractitionerMediaState] = useState<any>({});
  const [isMediaLoadedForClient, setIsMediaLoadedForClient] = useState<boolean>(false);
  const [isUploadedTab, setIsUploadedTab] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true;

    const refreshRate = setInterval(() => {
      BackendService.getCurrentState(sessionId, treatmentId)
        .then((latestMediaState: any) => {
          if (!latestMediaState) {
            return null;
          }

          if (isMounted) {
            // mediaURI may be absent in a reset/fresh state — a throw here would
            // skip setPractitionerMediaState and freeze the client on stale data
            setIsUploadedTab((latestMediaState.mediaURI ?? '').includes('storage.googleapis.com/file-service-library'));
            setPractitionerMediaState(latestMediaState);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }, delay);

    return () => {
      isMounted = false;
      clearInterval(refreshRate);
    };
  }, []);

  const {
    playbackType: isClientReactPLayerStarted,
    loadProgress,
    isVisible: isClientPlayerVisible,
    mediaType: clientMediaType,
    mediaURI: clientMediaURI,
    mediaState,
    mediaStereoMode,
  } = practitionerMediaState;

  useEffect(() => {
    const state = determineMediaState(mediaState);
    let timeoutId: NodeJS.Timeout;

    if (!!clientMediaURI) {
      setIsMediaLoadedForClient(true);
      return;
    }

    if (MediaStates.Loading === state) {
      setIsMediaLoadedForClient(false);
      timeoutId = setTimeout(() => {
        setIsMediaLoadedForClient(true);
      }, 1000);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [practitionerMediaState, setIsMediaLoadedForClient, clientMediaURI]);

  return {
    clientMediaType,
    loadProgress,
    isClientPlayerVisible,
    isClientReactPLayerStarted,
    clientMediaURI,
    mediaState,
    isMediaLoadedForClient,
    mediaStereoMode,
    isUploadedTab,
  };
};

export default useClientMediaState;
